import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AllowedCompanies from './allowed-companies';
import AllowedCompaniesDetail from './allowed-companies-detail';
import AllowedCompaniesUpdate from './allowed-companies-update';
import AllowedCompaniesDeleteDialog from './allowed-companies-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AllowedCompaniesUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AllowedCompaniesUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AllowedCompaniesDetail} />
      <ErrorBoundaryRoute path={match.url} component={AllowedCompanies} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AllowedCompaniesDeleteDialog} />
  </>
);

export default Routes;
